import { render, staticRenderFns } from "./UsageFilesList.vue?vue&type=template&id=235dfbc7&scoped=true&"
import script from "./UsageFilesList.vue?vue&type=script&lang=js&"
export * from "./UsageFilesList.vue?vue&type=script&lang=js&"
import style0 from "./UsageFilesList.vue?vue&type=style&index=0&id=235dfbc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235dfbc7",
  null
  
)

export default component.exports